import React, { useEffect, useState } from 'react';
import TableView from '../Table/Table';
import { tableHeadings } from '../../../utils/constants';
import { fetchAllTerminals, fetchTerminal, filteredData } from '../../../redux/actions/TerminalActions';
import { connect } from "react-redux";
import { setTerminalEdit, setTerminalID, setModified } from '../../../redux/actions/TerminalActions';

import { Panel, PanelHeader } from '../../header/panel/panel';
import { useNavigate } from 'react-router';
import { CsvBuilder } from 'filefy';

const Terminals = (props) => {

    const navigate = useNavigate()

    const [searchValue, setSearchValue] = useState('');

    const handleClick = (value) => {
        console.log(value.data.terminalID)
        props.setTerminalID(value.data.terminalID)
        navigate('/terminal/view')
    }

    useEffect(() => {
        props.fetchAllTerminals()
        props.setModified(false)
        props.filteredData()
    }, [])

    const handleSearch = (event) => {
        setSearchValue(event.target.value)
        let filteredTerminals = event.target.value && event.target.value.length ? props.TERMINALREDUCER.terminalsData.filter(terminal => {
            if (terminal.terminalID.toLowerCase().includes(event.target.value.toLowerCase()) || terminal.serialNumber.toLowerCase().includes(event.target.value.toLowerCase()) || terminal.locationName.toLowerCase().includes(event.target.value.toLowerCase()) || terminal.isoName.toLowerCase().includes(event.target.value.toLowerCase())) {
                return terminal
            }
            return null
        }) : props.TERMINALREDUCER.terminalsData
        props.filteredData(filteredTerminals)
    }

    const onNewTerminalAddClick = () => {
        navigate('/terminal/add')
    }

    const exportAllSelectedRows = () => {

        let terminalHeading = Number(props.LOGINREDUCER.USER.role) === 1 || Number(props.LOGINREDUCER.USER.role) === 6 ? tableHeadings.adminTerminals : tableHeadings.terminals

        new CsvBuilder("Terminals.csv")
            .setColumns(terminalHeading.map(col => col.headerName))
            .addRows(props.TERMINALREDUCER.terminalsData?.map(rowData => terminalHeading.map(col => rowData[col.field])))
            .exportFile();
    }

    return (

        <Panel>

            <PanelHeader>

                <div className="row mb-0">

                    <div className="col-xl-6">
                        <h4>Terminals</h4>
                    </div>
                    <div className="col-xl-2">
                        <input type="text" className="form-control" placeholder="Search..." onChange={handleSearch} />
                    </div>

                    <div className="col-xl-2">
                        {Number(props.LOGINREDUCER.USER.role) === 1 || Number(props.LOGINREDUCER.USER.role) === 6 ?
                            <button className="btn btn-sm btn-secondary d-block btn-lg h-35px fs-09px" onClick={onNewTerminalAddClick}>Add Terminal</button>
                            : null}
                    </div>
                    <div className="col-xl-2">
                        <button className="btn btn-sm btn-secondary d-block btn-lg h-35px fs-09px" onClick={exportAllSelectedRows}>Export Data</button>

                    </div>


                </div>


            </PanelHeader>

            <TableView height={596} count = {13} headings={Number(props.LOGINREDUCER.USER.role) === 1 || Number(props.LOGINREDUCER.USER.role) === 6 || Number(props.LOGINREDUCER.USER.role) === 7 ? tableHeadings.adminTerminals : tableHeadings.terminals} data={(props.TERMINALREDUCER.filteredData && props.TERMINALREDUCER.filteredData.length) || searchValue ? props.TERMINALREDUCER.filteredData : props.TERMINALREDUCER.terminalsData} handleClick={handleClick} />

        </Panel>


    )
}

function mapStateToProps(state) {
    return state
}

const mapDispatchToProps = {
    fetchAllTerminals,
    fetchTerminal,
    filteredData,
    setTerminalEdit,
    setTerminalID,
    setModified
}


export default connect(mapStateToProps, mapDispatchToProps)(Terminals);